/*
 * @Author: your name
 * @Date: 2020-11-09 17:00:18
 * @LastEditTime: 2021-02-25 14:52:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \aiot-design\src\common\components\locale\zh_CN.js
 */
const localeValues = {
  AIOTTable: {
    total: "共{total}条",
    tableIndex: "序号"
  },
  button: {
    add: '新增'
  },
  productTags: {
    delete: '刪除',
    addBtnTxt: '新增标签',
    placeholder: {
      key: '请输入标签key',
      value: '请输入标签value'
    }
  },
  UploadImage: {
    delete: '刪除',
    typeError: '图片类型错误！',
    sizeError: '图片大小错误！',
    title: '图片',
    clickUpload: '点击上传',
    tip1: '仅支持',
    tip2: '格式',
    tip3: '大小为',
    tip4: '以内'
  },
  Message: {
    ok: '确认',
    cancel: '取消'
  },
  noData: {
    content: '暂时没有数据哦~'
  },
  headerNav: {
    workbench: '工作台',
    'app-dev': '应用开发',
    server: '服务',
    'iot-middleware-platform': '物联中台',
    'knowledge-base': '知识库',
    ai: '人工智能',
    nav: '导航',
    'data-model': '数据建模',
    'thing-model': '物模型',
    "org-admin": "企业管理后台"
  },
  headerSettingEdge: {
    help: '帮助中心',
    menuSetting: '个人设置',
    menuLogout: '退出登录',
    headerImg: '头像',
    lang: '语言',
    systemLang: '系统语言',
    changePassword: "修改密码",
    licenseInfo: "许可信息"
  },
  headerSetting: {
    help: '帮助中心',
    menuSetting: '个人设置',
    menuLogout: '退出登录',
    headerImg: '头像',
    mail: '通讯录',
    lang: '语言',
    systemLang: '系统语言'
  },
  QuickTable: {
    delete: '刪除',
    deleteSuccess: '刪除成功！',
    deleteConfirm: '删除后将无法恢复，确定删除',
    editSuccess: '编辑成功！',
    edit: '编辑'
  },
  FormDialog: {
    add: '新增',
    edit: '编辑',
    cancel: '取消',
    save: '保存'
  },
  AccountModal: {
    account: "账号",
    accountBind: "账号绑定",
    accountPwd: "账号密码",
    avatar: "头像",
    baseSet: "基本设置",
    binded: "已绑定",
    cancel: "取消",
    confirmPwd: "确认密码",
    cpwdRequire: "确认密码为必填项",
    delSuccess: "已删除头像",
    deleteAvatar: "确定删除头像吗？",
    deleteSuccess: "删除成功",
    email: "邮箱",
    emailRule: "邮箱格式错误",
    loginAccount: "登录账号",
    modalTip: "请设置AloT账号密码，设置后可用本账号登陆",
    modify: "修改",
    modifyPwd: "修改密码",
    mustSame: "两次输入的密码不一致",
    name: "账号",
    newPwd: "新密码",
    newPwdRequire: "新密码为必填项",
    oldPwd: "旧密码",
    oldPwdRequire: "旧密码为必填项",
    password: "密码",
    personalInfo: "个人设置",
    phone: "手机",
    phoneRule: "手机号格式错误",
    pwdFail: "修改密码失败",
    pwdMustNew: "新密码不能与旧密码一致",
    pwdRequire: "密码为必填项",
    pwdSetFail: "设置密码失败",
    pwdSetSuccess: "设置密码成功",
    pwdSuccess: "修改密码成功",
    save: "保存",
    set: "设置",
    setPwd: "设置密码",
    success: "修改成功",
    trueName: "姓名",
    trueNameRule: "姓名不能大于20个字符",
    unBind: "未绑定",
    uploadFail: "上传失败",
    uploadSuccess: "上传成功",
    yht: "友户通",
    clickUpload: '点击上传',

    cantEmpty: "{name}不能为空",
    nameMax: "{name}长度不能超过{length}"
  }
}
export default localeValues;
